//#region IMPORT
import React, { useEffect, useRef, useState } from 'react';
import M_TBG_BASIC_08 from './M_TBG_BASIC_08';
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../Reducer/CommonReducer';
// useBackStack 훅 임포트
import { useBackStack } from '../../../Hooks/back/useBackStack';
//#endregion

function M_TBG_BASIC_08F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);

  // activeStep 최신값 참조를 위한 ref
  const activeStepRef = useRef(activeStep);
  useEffect(() => {
    activeStepRef.current = activeStep;
  }, [activeStep]);

  const [loading, setLoading] = useState(false);
  const [inputs, setInputs] = useState({
    tbmTitle: '',
    tbmComment: '',
    tbmAddress: '',
  });
  const [imageFile, setImageFile] = useState({
    mapFiles: '', // 파일 String
    mapImage: '', // 파일 객체
    mapFileName: '', // 파일 이름
  });
  const [modalToggle1, setModalToggle1] = useState(false); // 사진 다이어로그
  //#endregion

  // 뒤로가기 핸들러: useBackStack 사용
  useBackStack({
    type: 'custom',
    onBack: () => {
      // 사진 다이어로그가 열려 있으면 다이어로그만 닫기
      if (modalToggle1 === true) {
        setModalToggle1(false);
        return;
      }

      // 만약 다이어로그가 닫힌 상태에서 뒤로가기 시
      // 이전 스텝으로 이동해야 한다면 아래 주석을 해제하세요.
      // dispatch(CommonActions.setActiveStep(activeStepRef.current - 1));
    },
  });

  //#region 조회
  //#endregion

  //#region 저장
  // 파일 저장
  const SavePhoto = async (_file) => {
    setLoading(true);
    const filePath = `TBM/${props.tbmCdRef.current}/Photo`;
    let finalSavePath = '';
    try {
      let formList = new FormData();
      formList.append('UserId', userInfo.userid);
      formList.append('FilePath', filePath);
      formList.append('FormFile', _file);

      const result = await Commons.Axios(
        'file2',
        Global.file.useUrl + Global.urls.Execute.videoUpload,
        null,
        formList
      );

      finalSavePath = result?.data?.filePath || '';

      if (finalSavePath) {
        const savePath = finalSavePath
          .replace(/^.*\\PreviewFiles/, 'PreviewFiles')
          .replace(/\\/g, '/');

        return savePath;
      } else {
        dispatch(
          showSnackbar({
            message: '파일 업로드 실패 또는 파일 경로 없음',
            type: 'error',
          })
        );
        return null;
      }
    } catch (e) {
      console.error('SavePhoto Error:', e);
      return null;
    } finally {
      setLoading(false);
    }
  };

  // TBM 회의 내용 저장
  const SaveLogic1 = async () => {
    setLoading(true);
    let saveData = [];

    try {
      if (!inputs.tbmTitle) {
        dispatch(
          showSnackbar({ message: '제목을 입력하세요.', type: 'warning' })
        );
        return false;
      } else if (!inputs.tbmAddress) {
        dispatch(
          showSnackbar({ message: '장소를 입력하세요.', type: 'warning' })
        );
        return false;
      } else if (!inputs.tbmComment) {
        dispatch(
          showSnackbar({ message: '내용을 입력하세요.', type: 'warning' })
        );
        return false;
      } else {
        let photoPath = '';
        if (inputs.photoImg) {
          photoPath = await SavePhoto(inputs.photoImg);
        }

        saveData.push({
          procedureName: 'SP_M20907_U1',
          _tbmCd: Commons.EncryptAES(props.tbmCdRef.current) || '',
          _userid: userInfo.userid,
          _tbmTitle: Commons.EncryptAES(inputs.tbmTitle) || '',
          _tbmComment: Commons.EncryptAES(inputs.tbmComment) || '',
          _tbmPhoto: photoPath
            ? Commons.EncryptAES(
                `TBM/${props.tbmCdRef.current}/Photo/${inputs.photoNm}`
              )
            : '',
          _tbmAddress: Commons.EncryptAES(inputs.tbmAddress) || '',
        });

        if (saveData.length > 0) {
          const result = await Commons.Axios(
            'post1',
            Global.base.useUrl + Global.urls.Execute.execute,
            saveData
          );

          let data = result?.data[0];

          if (data.type === 'Error') {
            throw new Error(data.message);
          } else {
            dispatch(
              showSnackbar({ message: '저장되었습니다.', type: 'success' })
            );
            await SaveLogic2();
            await SaveLogic3(5, 8);
          }
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  // tbm 종료시간 업데이트
  const SaveLogic2 = async () => {
    setLoading(true);
    let saveData = [];
    try {
      saveData.push({
        procedureName: 'SP_M20908_U1',
        _tbmCd: Commons.EncryptAES(props.tbmCdRef.current) || '',
        _userid: userInfo.userid,
      });

      if (saveData.length > 0) {
        const result = await Commons.Axios(
          'post1',
          Global.base.useUrl + Global.urls.Execute.execute,
          saveData
        );
        if (result?.data[0]?.type === 'Error') {
          throw new Error(result?.data[0].message);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  // tbmstatus 교육현황 저장
  const SaveLogic3 = async (_eStep, _mStep) => {
    setLoading(true);
    let saveData = [];

    try {
      saveData.push({
        procedureName: 'SP_TBM_STATUS_U1',
        _TBM_CD: Commons.EncryptAES(props.tbmCdRef.current) || '',
        _E_STEP: Commons.EncryptAES(_eStep.toString()) || '',
        _M_STEP: Commons.EncryptAES(_mStep.toString()) || '',
        _USER_ID: userInfo.userid,
      });

      if (saveData.length > 0) {
        const result = await Commons.Axios(
          'post1',
          Global.base.useUrl + Global.urls.Execute.execute,
          saveData
        );
        let data = result?.data[0];

        if (data.type === 'Error') {
          throw new Error(data.message);
        } else {
          dispatch(CommonActions.setActiveStep(activeStepRef.current + 1));
        }
      }
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  return (
    <M_TBG_BASIC_08
      inputs={inputs}
      setInputs={setInputs}
      imageFile={imageFile}
      setImageFile={setImageFile}
      modalToggle1={modalToggle1}
      setModalToggle1={setModalToggle1}
      SaveLogic1={SaveLogic1}
      ActiveButton={props.ActiveButton}
    />
  );
}

export default M_TBG_BASIC_08F;
